// tslint:disable:no-console
export const logger = (store: any) => (next: any) => (action: any) => {
  // Uncomment if you need it. use redux devtools for better debugging
  // console.log('dispatching', action)
  const result = next(action);
  // console.log('next state', store.getState());
  // console.log('result --> ', result)
  return result;
};
